module.exports = __webpack_public_path__ + "img/MapThumb_FertileValley.eda16cdc.webp";